import { useState } from 'react';

import { DynamicUspList } from '../UspList/DynamicUspList';
import { DynamicUspListOld } from '../UspList/DynamicUspListOld';

import type { USPRenderProps } from './MainLayoutV3';

export const USPTextRenderOld = ({
  uspLayout,
  hideUSP,
  upsItems,
  localizedUspLabel,
  classes,
}: USPRenderProps): JSX.Element => {
  if (hideUSP) {
    return <></>;
  }

  return uspLayout === 'vertical' ? (
    <div css={classes.uspWrapper as any}>
      <div css={[classes.uspContainer, classes.uspContainerVertical] as any}>
        <DynamicUspListOld upsItems={upsItems} localizedUspLabel={localizedUspLabel} />
      </div>
    </div>
  ) : (
    <div css={classes.uspContainer as any}>
      <DynamicUspListOld upsItems={upsItems} localizedUspLabel={localizedUspLabel} />
    </div>
  );
};

export const USPTextRender = ({
  hideUSP,
  upsItems,
  localizedUspLabel,
  classes,
}: USPRenderProps): JSX.Element => {
  const [isClosed, setIsClosed] = useState(false);
  if (hideUSP) {
    return <></>;
  }

  if (isClosed) {
    return <></>;
  }

  return (
    <div css={classes.uspWrapper as any}>
      <DynamicUspList
        upsItems={upsItems}
        localizedUspLabel={localizedUspLabel}
        setIsClosed={setIsClosed}
      />
    </div>
  );
};
